export default __webpack_public_path__ + "static/media/house-8.f096672f.jpg";